import React, { useState } from "react";
import Benefits from "components/benefits";
import EnquiryForm from "components/forms/EnquiryForm";
import { JumbotronPF } from "sections";
import RizeAd from "sections/Home/RizeAd";
import { InfoItem } from "components/pf";
import "sections/sections.css";
import { ClickableButton } from "components/buttons";
import Eligibility from "components/eligibility";
import { handleOpenPdf } from "utils";
import { ASSETS_BASE_URL } from "constants";
import benefit1 from "assets/images/microsite/benefits/benefit1.png";
import benefit2 from "assets/images/microsite/benefits/benefit2.png";
import benefit3 from "assets/images/microsite/benefits/benefit3.png";
import benefit4 from "assets/images/microsite/benefits/benefit4.png";
import benefit5 from "assets/images/microsite/benefits/benefit5.png";
import benefit6 from "assets/images/microsite/benefits/benefit6.png";
import benefit7 from "assets/images/microsite/benefits/benefit7.png";
import benefitsMobile from "assets/images/microsite/benefits/benefits_mobile.png";
import CalculatorUmrah from "components/calculator/CalculatorUmrah";
import FloatingButton from "components/fab/FloatingButton";

const MicrositeUmrah = () => {
  const [incomeRange, setIncomeRange] = useState("below5k");

  const handleIncomeRangeChange = (range) => {
    setIncomeRange(range);
  };
  const pfEligibility = {
    type: "pfumrah",
    title: "Permohonan mudah",
    documentsTitle: "Dokumen Diperlukan",
    employeeType: "Pekerja bergaji",
    eligibilityTitle: "Kelayakan",
    yearsOld: "tahun",
    highlightedText: "\ndengan 2 langkah sahaja",
    documents: [
      {
        text: "<b>Penyata KWSP</b> terkini",
        backgroundColor: "#DCE9FF",
      },
      {
        text: "<b>Slip gaji 3 bulan terkini</b> dan penyata bank yang menunjukkan pengkreditan gaji",
        backgroundColor: "#F2F4F7",
      },
    ],
    ageRange: {
      minimum: {
        value: incomeRange === "below5k" ? "21" : "25",
        label: "Umur minima",
      },
      maximum: {
        value: incomeRange === "below5k" ? "35" : "60",
        label: "Umur maksima",
      },
    },
    income: {
      range:
        incomeRange === "below5k" ? "RM3,000 - < RM5,000" : "RM5,000 & above",
      description: "pendapatan bulanan minima",
    },
  };

  const pfBenefitsDataBelow5k = [
    {
      title: (
        <>
          <span style={{ color: "#221AFB" }}>Kadar pembiayaan</span> serendah
        </>
      ),
      content: (
        <h2 id="benefits_below5k" className="benefits-text">
          5.78% setahun{" "}
        </h2>
      ),
      delay: "100",
    },
    {
      title: (
        <>
          <span style={{ color: "#221AFB" }}>Had pembiayaan</span> sehingga
        </>
      ),
      content: (
        <h2 id="benefits_below5k" className="benefits-text">
          RM50,000
        </h2>
      ),
      delay: "200",
    },
    {
      title: (
        <>
          <span style={{ color: "#221AFB" }}>Tempoh pembiayaan</span> sehingga
        </>
      ),
      content: (
        <h2 id="benefits_below5k" className="benefits-text">
          8 tahun
        </h2>
      ),
      delay: "300",
    },
    {
      title: (
        <>
          Tidak memerlukan<span style={{ color: "#221AFB" }}> cagaran</span>{" "}
          atau <span style={{ color: "#221AFB" }}>penjamin</span>
        </>
      ),
      delay: "300",
    },
    {
      title: (
        <>
          Pilihan untuk{" "}
          <span style={{ color: "#221AFB" }}>
            Perlindungan Takaful Kemalangan Diri
          </span>
        </>
      ),
      delay: "300",
    },
    {
      title: (
        <>
          Umrah bersama panel{" "}
          <span style={{ color: "#221AFB" }}>
            Agensi Pelancongan yang berdaftar
          </span>{" "}
          dan{" "}
          <span style={{ color: "#221AFB" }}>
            mempunyai rekod prestasi yang terbukti
          </span>
        </>
      ),
      delay: "300",
    },
  ];

  const pfBenefitsDataAbove5k = [
    {
      title: (
        <>
          <span style={{ color: "#221AFB" }}>Kadar pembiayaan</span> serendah
        </>
      ),
      content: (
        <h2 id="benefits_below5k" className="benefits-text">
          5.94% setahun{" "}
        </h2>
      ),
      delay: "100",
    },
    {
      title: (
        <>
          <span style={{ color: "#221AFB" }}>Had pembiayaan</span> sehingga
        </>
      ),
      content: (
        <h2 id="benefits_below5k" className="benefits-text">
          RM250,000{" "}
        </h2>
      ),
      delay: "200",
    },
    {
      title: (
        <>
          <span style={{ color: "#221AFB" }}>Tempoh pembiayaan</span> sehingga
        </>
      ),
      content: (
        <h2 id="benefits_below5k" className="benefits-text">
          8 tahun
        </h2>
      ),
      delay: "300",
    },
    {
      title: (
        <>
          Tidak memerlukan<span style={{ color: "#221AFB" }}> cagaran</span>{" "}
          atau <span style={{ color: "#221AFB" }}>penjamin</span>
        </>
      ),
      delay: "300",
    },
    {
      title: (
        <>
          Pilihan untuk{" "}
          <span style={{ color: "#221AFB" }}>
            Perlindungan Takaful Kemalangan Diri
          </span>
        </>
      ),
      delay: "300",
    },
    {
      title: (
        <>
          Umrah bersama panel{" "}
          <span style={{ color: "#221AFB" }}>
            Agensi Pelancongan yang berdaftar
          </span>{" "}
          dan{" "}
          <span style={{ color: "#221AFB" }}>
            mempunyai rekod prestasi yang terbukti
          </span>
        </>
      ),
      delay: "300",
    },
  ];

  const pfBenefitsConfig = {
    heading: "Manfaat",
    tnc: "*Tertakluk kepada terma dan syarat",
    benefitsData:
      incomeRange === "below5k" ? pfBenefitsDataBelow5k : pfBenefitsDataAbove5k,
    desktopImages: `${ASSETS_BASE_URL}assets/images/pf/umrah.png`,
    mobileImage: `${ASSETS_BASE_URL}assets/images/pf/umrah.png`,
    tncLink: "/tnc",
  };

  return (
    <div>
      <section
        className="section jumbotron"
        data-aos="zoom-out"
        data-aos-delay="200"
        style={{ paddingBottom: "8vh" }}
      >
        <JumbotronPF
          badgeText={
            <span>
              Pembiayaan Peribadi Umrah-<i>i</i>
            </span>
          }
          title={`Umrah bersama keluarga<br><span className="jumbotron-subtitle-2">kini lebih mudah!</span>`}
          subText={
            <span>
              Kemudahan pembiayaan untuk merealisasikan impian anda dan keluarga
              tersayang menunaikan umrah bersama kami.
            </span>
          }
          buttonText="Mohon sekarang"
          onIncomeRangeChange={handleIncomeRangeChange}
          calculatorComponent={CalculatorUmrah}
        />
      </section>

      <Benefits heading="Benefits" {...pfBenefitsConfig} />
      <Eligibility {...pfEligibility} />
      <section className="section about container">
        <div
          className="row align-items-center"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <div className="col-md-4 order-lg-1 order-2 img-fluid-pf">
            <img
              src={"https://www.alrajhibank.com.my/assets/images/pf/alia.svg"}
              alt="Rates and charges"
              className="img-fluid-pf"
            />
          </div>
          <div
            className="col-md-8 order-lg-2 order-1"
            data-aos="zoom-in"
            data-aos-delay="200"
          >
            <div className="pf-rates pb-4">
              <span>Manfaat yang akan diperoleh oleh Jemaah:</span>
            </div>
            <div className="col">
              <InfoItem
                subheader={
                  <span
                    style={{
                      fontSize: "1.2rem",
                      fontWeight: 400,
                      color: "#000045",
                    }}
                  >
                    Jaringan{" "}
                    <span style={{ color: "#221AFB" }}>
                      kemudahan perbankan terbesar
                    </span>{" "}
                    di tanah suci
                  </span>
                }
                className="col-xl-12"
              />
              <InfoItem
                subheader={
                  <span
                    style={{
                      fontSize: "1.2rem",
                      fontWeight: 400,
                      color: "#000045",
                    }}
                  >
                    Pakej yang memberi{" "}
                    <span style={{ color: "#221AFB" }}>
                      kemudahan untuk membawa keluarga tersayang
                    </span>{" "}
                    untuk menunaikan ibadah Umrah
                  </span>
                }
                className="col-xl-12"
              />
              <InfoItem
                subheader={
                  <span
                    style={{
                      fontSize: "1.2rem",
                      fontWeight: 400,
                      color: "#000045",
                    }}
                  >
                    <span style={{ color: "#221AFB" }}>Kadar menarik</span> bagi
                    produk Pembiayaan Peribadi Umrah-<i>i</i>
                  </span>
                }
                className="col-xl-12"
              />
            </div>
          </div>
        </div>
      </section>
      <section
        className="section about container"
        data-aos="fade-up"
        data-aos-delay="200"
      >
        <div className="d-flex forms pt-4 justify-content-center align-text-center">
          <span>Borang permohonan & Lampiran</span>
        </div>
        <div className="link-button-row-pf justify-content-center">
          <div
            className="link-button-row-pf pt-5 justify-content-center"
            data-aos="fade-left"
            data-aos-delay="200"
          >
            <ClickableButton
              variant="primary"
              text={
                <span>
                  Borang Permohonan Pembiayaan Peribadi-<i>i</i>
                </span>
              }
              onClick={() =>
                handleOpenPdf(
                  `${ASSETS_BASE_URL}assets/pdf/personal-financing/PF_application_form.pdf`
                )
              }
            />
            <ClickableButton
              text="Borang Pendedahan Produk"
              onClick={() =>
                handleOpenPdf(
                  `${ASSETS_BASE_URL}assets/pdf/personal-financing/PDS-PF(Mass).pdf`
                )
              }
            />

            <ClickableButton
              text="Lampiran 2 - Borang Potongan (English)"
              onClick={() =>
                handleOpenPdf(
                  `${ASSETS_BASE_URL}assets/pdf/personal-financing/PF Appendix 2 Deduction Form ENG - Final.pdf`
                )
              }
            />
          </div>
          <div
            className="link-button-row-pf pt-1 justify-content-center"
            data-aos="fade-right"
            data-aos-delay="200"
          >
            <ClickableButton
              text="Lampiran 2 - Borang Potongan (Bahasa Melayu)"
              onClick={() =>
                handleOpenPdf(
                  `${ASSETS_BASE_URL}assets/pdf/personal-financing/PF Appendix 2 Deduction Form BM -Final.pdf`
                )
              }
            />
            <ClickableButton
              text="Lampiran 3 - Syarat Tambahan (English)"
              onClick={() =>
                handleOpenPdf(
                  `${ASSETS_BASE_URL}assets/pdf/personal-financing/PF Appendix 3.pdf`
                )
              }
            />
            <ClickableButton
              text="Lampiran 3 - Syarat Tambahan (Bahasa Melayu)"
              onClick={() =>
                handleOpenPdf(
                  `${ASSETS_BASE_URL}assets/pdf/personal-financing/BM_3 Clean Appendix 3.pdf`
                )
              }
            />
          </div>
        </div>
      </section>
      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4" data-aos="fade-left" data-aos-delay="200">
            <h3 style={{ color: "#000045" }}>Hubungi kami  </h3>
            <p>
              Sila isikan butiran anda dan wakil perkhidmatan kami akan hubungi
              anda.
            </p>
          </div>
          <div className="col-xl-8" data-aos="fade-up" data-aos-delay="200">
            <EnquiryForm />
          </div>
        </div>
      </section>
      <RizeAd />
      <FloatingButton />
    </div>
  );
};

export default MicrositeUmrah;
